const getCurrentRoute = (location: any) => {
  const activeLink = location.pathname;
  const routeArr = activeLink?.split('/');
  const lastRoute = routeArr[routeArr?.length - 1];
  return lastRoute;
};

export default getCurrentRoute;
